import $ from 'jquery'

function initTeamBlock () {
  const $teamBlock = $('.team-block')

  if (!$teamBlock.length) return

  const $tabList = $teamBlock.find('[role="tablist"]')
  if ($tabList.length) {
    initFilters($teamBlock, $tabList)
  }
}

function initFilters ($teamBlock, $tabList) {
  const $items = $teamBlock.find('.team-block__item')

  $tabList.on('click', '[role="tab"]', function () {
    const $tabNav = $(this)
    const category = $tabNav.data('job')

    if ($tabNav.attr('aria-selected') === 'true') return

    $tabList.find('[role="tab"]').attr('aria-selected', 'false')
    $tabNav.attr('aria-selected', 'true')

    $items.fadeOut(300, () => {
      setTimeout(() => {
        const $filteredItems = category === 'all'
          ? $items
          : $teamBlock.find(`[data-jobs*="${category}"]`)

        $filteredItems.fadeIn(300)
      }, 300)
    })
  })
}

export { initTeamBlock }
